import fetch from 'cross-fetch'
import firebase from './firebase'

export const REQUEST_POSTS = 'REQUEST_POSTS'
export const RECEIVE_POSTS = 'RECEIVE_POSTS'
export const SELECT_JOB = 'SELECT_JOB'
export const ADD_JOB = 'ADD_JOB'
export const SELECT_TERM = 'SELECT_TERM'
export const INVALIDATE_JOB = 'INVALIDATE_JOB'

const urls = [
  `https://cors-anywhere.herokuapp.com/https://codepen.io/jobs.json`,
  `https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions.json`,
  `https://cors-anywhere.herokuapp.com/https://remoteok.io/remote-jobs.json`,
  `https://cors-anywhere.herokuapp.com/https://landing.jobs/feed`,
  `https://cors-anywhere.herokuapp.com/https://goremote.io/api/jobs/`,
	`https://cors-anywhere.herokuapp.com/https://www.workingnomads.co/api/exposed_jobs/`,
	`https://cors-anywhere.herokuapp.com/https://stackoverflow.com/jobs/feed?l=Remote&u=Km&d=20`,
	`https://cors-anywhere.herokuapp.com/http://api.remotebase.io/jobs`,
	`https://cors-anywhere.herokuapp.com/https://www.wfh.io/jobs.atom`,
	`https://cors-anywhere.herokuapp.com/https://react.42jobs.io/jobs.rss`
]
let allJobs = [];

export function selectJob(job) {
  return {
    type: SELECT_JOB,
    job
  }
}

export function invalidateJob(job) {
  return {
    type: INVALIDATE_JOB,
    job
  }
}

function requestPosts(job) {
  return {
    type: REQUEST_POSTS,
    job
  }
}

function uniqBy(a, key) {
    var seen = new Set();
    return a.filter(item => {
        var k = key(item);
        return seen.has(k) ? false : seen.add(k);
    });
}

function removeDuplicates(myArr, prop) {
	return myArr.filter((obj, pos, arr) => {
			return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
	});
}

function receivePosts(job, searchText, keyword, json) {
  var array;
  allJobs = allJobs.concat(json);
  const uniqueArray = uniqBy(allJobs, JSON.stringify);
  for (let i = 0; i < uniqueArray.length; i++) {
    uniqueArray[i].id = uniqueArray[i].url || uniqueArray[i].applyurl;
	}
	const uniqueArray1 = removeDuplicates(allJobs, 'id');
  var filteredArray = uniqueArray.filter((jobItem) => {
    if (jobItem.tags) {
			var tags = jobItem.tags;
      return Object.values(tags).indexOf(job) > -1;
		} else if (jobItem.title) {
			var de = jobItem.title.includes(job);
			if (de) {
				return true;
			}	else if (jobItem.description) {
				var de1 = jobItem.description;
				return de1.includes(job);
			} else {
				return false;
			}
		} else if (jobItem.position) {
			var de2 = jobItem.position.includes(job);
			if (de2) {
				return true;
			}	else if (jobItem.description) {
				var de3 = jobItem.description;
				return de3.includes(job);
			} else {
				return false;
			}
		} else {
			return false;
		}
	})
  if (job === "All") {
    array = uniqueArray1
  } else {
    array = filteredArray
	}
  return {
    type: RECEIVE_POSTS,
    job,
    posts: array,
		receivedAt: Date.now(),
		searchText,
		keyword
  }
}

function addJob(job) {
	return {
		type: ADD_JOB,
		...job
	}
};

export const publishJob = (post) => {
	return function (dispatch) {
		let postToSave = {title: post.title,
			company: post.company,
			description: post.description,
			url: post.url,
			created_at: Date(),
			sponsored: true
		};
		firebase.database().ref().child('posts').push().set(postToSave);
		// postToSave.id = newJobRef.key + "sponsored";
		// newJobRef.set(postToSave);
		dispatch(addJob(postToSave));
	};
};

function fetchPosts(job, searchText, keyword) {
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[0])
      .then(response => response.json())
			.then(json => dispatch(receivePosts(job, searchText, keyword, json.jobs)))
  }
}

function fetchAnotherPosts(job, searchText, keyword) {
	return dispatch => {
		fetch(urls[1])
		.then(response => response.json())
		.then(json => dispatch(receivePosts(job, searchText, keyword, json)))
  }
}

function fetchAnotherPosts2(job, searchText, keyword) {
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[2])
      .then(response => response.json())
      .then(json => dispatch(receivePosts(job, searchText, keyword, json)))
	}
}

function fetchAnotherPosts3(job, searchText, keyword) {
  let jayson = [];
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[3])
      .then(response => response.text())
      .then(str => (new window.DOMParser()).parseFromString(str, "text/xml"))
      .then(data => {
        xmlToJson(data).feed.entry.map(job => {
          job = {
            title: job.title["#text"],
            url: job.link["@attributes"].href,
            company: job.author.name["#text"],
						date: job.published
          }
          return jayson.push(job);
        })
      })
      .then(json => dispatch(receivePosts(job, searchText, keyword, jayson)))
  }
}

function fetchAnotherPosts4(job, searchText, keyword) {
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[4])
      .then(response => response.json())
      .then(json => dispatch(receivePosts(job, searchText, keyword, json)))
  }
}

function fetchAnotherPosts5(job, searchText, keyword) {
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[5])
      .then(response => response.json())
      .then(json => {
				dispatch(receivePosts(job, searchText, keyword, json))
			})
  }
}

function fetchAnotherPosts6(job, searchText, keyword) {
	let jayson = [];
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[6])
		.then(data => {
			let xmlDoc = new DOMParser().parseFromString(data._bodyText, 'text/xml');
			xmlToJson(xmlDoc).rss.channel.item.map(job => {
				job = {
					title: job["title"]["#text"],
					description: job.description["#text"],
					url: job.link["#text"],
					company: job["a10:author"]["a10:name"]["#text"],
					date: job.pubDate["#text"]

				}
				return jayson.push(job);
			})
		})
		.then(json => dispatch(receivePosts(job, searchText, keyword, jayson)))
  }
}

function fetchAnotherPosts7(job, searchText, keyword) {
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[7])
      .then(response => {
				return response.json()
			})
			.then(json => {
				json.jobs.forEach((el) => {
					el.company = el.company.name;
					el.countries = "";
				});
				return json.jobs
			})
      .then(json => dispatch(receivePosts(job, searchText, keyword, json)))
  }
}

function fetchAnotherPosts8(job, searchText, keyword) {
	let jayson = [];
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[8])
		.then(data => {
			let xmlDoc = new DOMParser().parseFromString(data._bodyText, 'text/xml');
			setTimeout(
				xmlToJson(xmlDoc).feed && xmlToJson(xmlDoc).feed.entry.map(job => {
					job = {
						title: job["title"]["#text"],
						description: job.content["#text"],
						url: job.link["@attributes"].href,
						date: job.published["#text"]
				}
				return jayson.push(job);
			}), 500);
		})
		.then(json => dispatch(receivePosts(job, searchText, keyword, jayson)))
  }
}

function fetchAnotherPosts9(job, searchText, keyword) {
	let jayson = [];
  return dispatch => {
    dispatch(requestPosts(job))
    fetch(urls[9])
		.then(data => {
			let xmlDoc = new DOMParser().parseFromString(data._bodyText, 'text/xml');
			xmlToJson(xmlDoc).rss.channel.item.map(job => {
				job = {
					title: job.title["#text"],
					company: job.author["#text"],
					description: job.description["#text"],
					url: job.link["#text"],
					date: job.pubDate["#text"]
				}
				return jayson.push(job);
			})
		})
		.then(json => dispatch(receivePosts(job, searchText, keyword, jayson)))
  }
}

function fetchSponsoredPosts(job, searchText, keyword) {
	let values = [];
	return dispatch => {
		dispatch(requestPosts(job))
		firebase.database().ref().child('posts').once('value').then(snapshot => {
			const response2 = snapshot.val();
			values = response2 ? Object.keys(response2).map(function(e) {
				return response2[e];
			}) : [];
		})
		.then(json => dispatch(receivePosts(job, searchText, keyword, values)))
	}
}

function doEverything(job, searchText, keyword) {
  return dispatch => Promise.all([
    dispatch(fetchPosts(job, searchText, keyword)),
    dispatch(fetchAnotherPosts(job, searchText, keyword)),
    dispatch(fetchAnotherPosts2(job, searchText, keyword)),
    dispatch(fetchAnotherPosts3(job, searchText, keyword)),
    dispatch(fetchAnotherPosts4(job, searchText, keyword)),
		dispatch(fetchAnotherPosts5(job, searchText, keyword)),
		dispatch(fetchAnotherPosts6(job, searchText, keyword)),
		dispatch(fetchAnotherPosts7(job, searchText, keyword)),
		dispatch(fetchAnotherPosts8(job, searchText, keyword)),
		dispatch(fetchAnotherPosts9(job, searchText, keyword)),
		dispatch(fetchSponsoredPosts(job, searchText, keyword))
  ]);
}

function shouldFetchPosts(state, job, searchText, keyword) {
	const posts = state.postsByJob[job]
  if (!posts || searchText.length > 2) {
    return true
  } else if (posts.isFetching) {
    return false
  } else {
    return posts.didInvalidate
  }
}

// Changes XML to JSON
function xmlToJson(xml) {
	let obj = {};
  if (xml) {
    if (xml.nodeType === 1) {
      if (xml.attributes.length > 0) {
      obj["@attributes"] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          let attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      obj = xml.nodeValue;
    }
    if (xml.hasChildNodes()) {
      for(let i = 0; i < xml.childNodes.length; i++) {
        let item = xml.childNodes.item(i);
				let nodeName = item.nodeName;
        if (typeof(obj[nodeName]) === "undefined") {
          obj[nodeName] = xmlToJson(item);
        } else {
          if (typeof(obj[nodeName].push) === "undefined") {
            let old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(xmlToJson(item));
        }
      }
    }
  }

	return obj;
};

export function fetchPostsIfNeeded(job, searchText, keyword) {
  return (dispatch, getState) => {
    if (shouldFetchPosts(getState(), job, searchText, keyword)) {
      return dispatch(doEverything(job, searchText, keyword));
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions.js